(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-vip-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lp-vip-offer')) {
    customElements.define('lp-vip-offer', class extends HTMLElement {
      connectedCallback() {
        const end = Date.parse('2026-11-07T08:00:00Z');
        const remaining = end - Date.now();
        this.hidden = remaining <= 0;
        if (remaining > 0) this.expiryTimer = setTimeout(() => { this.hidden = true; }, remaining);
      }
      disconnectedCallback() { clearTimeout(this.expiryTimer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
